// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Ol4R","main":"styles_main__4I6Zz","title":"styles_title__2Yiih","rejectionMessageButton":"styles_rejectionMessageButton__5T0it"};